import React from "react"
import { FaTwitterSquare } from "react-icons/fa"
import { FaVk } from "react-icons/fa"
import { FaFacebook } from "react-icons/fa"
import { FaYoutube } from "react-icons/fa"
import { FaTelegram } from "react-icons/fa"
import { RiInstagramFill } from "react-icons/ri"
import { FaEnvelope } from "react-icons/fa"
import { FaPhoneAlt } from "react-icons/fa"

const SocialButtons = ({
  telegramUrl,
  twitterUrl,
  youtubeUrl,
  facebookUrl,
  instagramUrl,
  vkUrl,
  phoneUrl,
  email,
}) => {
  return (
    <div className="py-5">
      <section className="flex items-center justify-center md:justify-start">
        {telegramUrl != null && (
          <span className="pr-2">
            <a
              href={telegramUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="telegram"
              className="font-semibold text-lg hover:underline"
            >
              <FaTelegram className="icon" />
            </a>
          </span>
        )}
        {instagramUrl != null && (
          <span className="pr-2">
            <a
              href={instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="telegram"
              className="font-semibold text-lg hover:underline"
            >
              <RiInstagramFill className="icon" />
            </a>
          </span>
        )}
        {twitterUrl != null && (
          <span className="pr-2">
            <a
              href={twitterUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="twitter"
              className="font-semibold text-lg hover:underline"
            >
              <FaTwitterSquare className="icon" />
            </a>
          </span>
        )}
        {youtubeUrl != null && (
          <span className="pr-2">
            <a
              href={youtubeUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="youtube"
              className="font-semibold text-lg hover:underline"
            >
              <FaYoutube className="icon" />
            </a>
          </span>
        )}
        {facebookUrl != null && (
          <span className="pr-2">
            <a
              href={facebookUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="facebook"
              className="font-semibold text-lg hover:underline"
            >
              <FaFacebook className="icon" />
            </a>
          </span>
        )}
        {vkUrl != null && (
          <span className="pr-2">
            <a
              href={vkUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="vk"
              className="font-semibold text-lg hover:underline"
            >
              <FaVk className="icon" />
            </a>
          </span>
        )}
        {phoneUrl != null && (
          <span className="pr-2">
            <a
              href={phoneUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="phone"
              className="font-semibold text-lg hover:underline"
            >
              <FaPhoneAlt className="icon" />
            </a>
          </span>
        )}
        {email != null && (
          <span className="pr-2">
            <a
              href={email}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="email"
              className="font-semibold text-lg hover:underline"
            >
              <FaEnvelope className="icon" />
            </a>
          </span>
        )}
      </section>
    </div>
  )
}

export default SocialButtons
